/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shift_Line_Back_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Shift Line Up" |
*
* @param {Shift_Line_Back_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shift_line_back_aria_label = /** @type {((inputs?: Shift_Line_Back_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shift_Line_Back_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler la Ligne en Haut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schichtaufstellung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Shift Line Up")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Построение смены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alineación de turnos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("轮班安排")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シフトラインアップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शिफ्ट लाइन अप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhamento de turnos")
	return /** @type {LocalizedString} */ ("Shift Line Up")
});